module.exports = __webpack_public_path__ + "img/yuliangg.17b837c5.png";